
export enum ValidityDeterminate {
	Valid = 'valid',
	Invalid = 'invalid',
	Abnormal = 'abnormal',
	OutOfRange = 'outOfRange',
	Required = 'required',
}

export interface ConceptStatusValidity {
	determinate: ValidityDeterminate
	message?: string
}

export type ConceptStatusValidityByCid = Record<string, ConceptStatusValidity>
